import { render } from "./BackgroundCode.vue?vue&type=template&id=8844af0e&scoped=true"
import script from "./BackgroundCode.vue?vue&type=script&lang=js"
export * from "./BackgroundCode.vue?vue&type=script&lang=js"

import "./BackgroundCode.vue?vue&type=style&index=0&id=8844af0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8844af0e"]])

export default __exports__